import React, {useCallback} from "react";
import {Button, Modal, Row, Col, Typography, Divider, Flex} from "antd";
import {PhoneOutlined} from "@ant-design/icons";
import {appConfiguration} from "@/setup";
import {useStore} from "@/store/useStore";
import {useAuth} from "@/provider/auth/useAuth";
import {useNavigate} from "react-router-dom";
import {getPersonPageRoute} from "@/routes/routes";
const { Title, Text } = Typography;

const ZAPORIZHZHIA_REGION_LABEL = 'Запорізька область';
const ZAPORIZHZHIA_HOTLINE = '0636585422';

export const ReserveModal = (props: any) => {
    const {isAuthenticated} = useAuth();
    const navigate = useNavigate();
    const {
        showLoginOrRegistrationModal, showReserveModal, setShowReserveModal, setIdToShowInReserveModal,
        idToShowInReserveModal, mtpFilters, regionOptions
    } = useStore();

    const isZaporizhzhiaRegionSelected = regionOptions.some(
        region => region.value === mtpFilters.regionId && region.label === ZAPORIZHZHIA_REGION_LABEL
    );

    const callClickedHandler = useCallback(() => {
        const link = document.createElement('a');
        link.href = `tel:${appConfiguration.hotline}`;
        link.click();
    }, []);

    const onLoginOrRegisterClicked = useCallback(() => {
        setTimeout(() => setShowReserveModal(false), 100);
        if(isAuthenticated) {
            navigate(getPersonPageRoute(), { replace: true });
        } else {
            showLoginOrRegistrationModal(true);
        }
    }, []);

    const onReserveCanceled = useCallback(() => {
        setShowReserveModal(false);
        setIdToShowInReserveModal(null);
    }, []);
    
    const renderStepNumber = (str: string) => (
        <span className="w-9 h-9 rounded-full bg-[#f0f0f0] flex items-center justify-center">
            <span className="leading-[18px] text-base font-bold">{str}</span>
        </span>
    )
    
    const renderContent = () => (
        <div className="max-w-[740px] my-10 mx-auto p-5 text-center">
            <Title level={2} style={{ fontWeight: 400, fontSize: '46px' }}>Завершити бронювання</Title>

            <Text type="secondary" style={{ display: 'block', margin: '30px 0px', fontSize: '18px', lineHeight: '22px' }}>
                Ви можете забронювати по телефону
            </Text>

            <Row align="middle" gutter={[16, 16]} className="mb-[20px]">
                <Col flex="1 1 300px" className="text-left min-w-[250px]">
                    <Flex justify='center' align='center' gap={8}>
                        {renderStepNumber("1")}
                        <span className="flex-1 text-[20px] font-medium leading-6">Зателефонуйте на безкоштовну гарячу лінію за номером</span>
                    </Flex>
                </Col>
                <Col flex="0 0 auto" className="min-w-[150px] mx-auto">
                    <Button
                        icon={<PhoneOutlined rotate={90} />}
                        onClick={callClickedHandler}
                        shape="round"
                        block
                        style={{ border: '1px solid #d9d9d9', height: '44px' }}
                    >
                        <div className="font-bold text-2xl rounded-sm">
                            {appConfiguration.hotline}
                        </div>
                    </Button>
                </Col>
            </Row>

            <Row align="middle" gutter={[16, 16]} className="mb-[40px]">
                <Col flex="1 1 300px" className="text-left min-w-[250px]">
                    <Flex justify='center' align='center' gap={8}>
                        {renderStepNumber("2")}
                        <span className="flex-1 text-[20px] font-medium leading-6">Назвіть унікальний номер приміщення для працівника гарячої лінії</span>
                    </Flex>
                </Col>
                <Col flex="0 0 auto" className="min-w-[150px] mx-auto">
                    <div className="bg-[#e6f4f1] p-2 text-center font-bold text-2xl rounded-sm">
                        {idToShowInReserveModal}
                    </div>
                </Col>
            </Row>

            {isZaporizhzhiaRegionSelected && (
                <div className="mb-[8px] text-center text-[20px] font-bold leading-6">
                    Для Запорізької області телефон гарячої лінії&nbsp; - &nbsp;{ZAPORIZHZHIA_HOTLINE}
                </div>
            )}

            <Divider plain style={{ borderColor: 'rgba(0, 0, 0, 0.5)' }}/>

            <Button
                type="primary"
                size="large"
                icon={<PhoneOutlined rotate={90} />}
                onClick={callClickedHandler}
                style={{borderRadius: '30px', height: '50px', padding: '0 40px', marginBottom: '20px'}}
            >
                Забронювати
            </Button>
            <Row gutter={[16, 16]}>
                <Col flex='auto'>
                    <Flex justify='center' align='center' className="text-[#bfbfbf] text-lg">
                        Заявка на бронювання здійснюється виключно безкоштовно!
                    </Flex>
                </Col>
            </Row>
        </div>
    );

    return (
        <Modal
            zIndex={17}
            key="reserve-modal"
            centered
            open={showReserveModal}
            footer={null}
            destroyOnHidden
            width={'800px'}
            onCancel={onReserveCanceled}
        >
            {renderContent()}
        </Modal>
    );
    
}
